import React, { useContext } from 'react';
import { QuizContext } from "./ConfigurableQuizContainer";

import ElementHTML from "./QuizElementHTML";
import Choices from "./QuizChoices";
import styled from "@emotion/styled";
import { keyframes} from "@emotion/react";
import { colors } from "@atlaskit/theme";
import Button from '@atlaskit/button';
import ProgressBar from '@atlaskit/progress-bar';
import ChevronDown from "@atlaskit/icon/glyph/chevron-down";
import ChevronRight from "@atlaskit/icon/glyph/chevron-right";

export default function During() {

  const { maximumQuestions, firstPage, labels, prevStep, currStep, currentCard, goToNextCard, goToPreviousCard, cardChoiceChange, toggleCardContent } = useContext(QuizContext);

  const extraIcon = currentCard.isShowingExtraContent ? <ChevronDown/> : <ChevronRight />;
  const cardIsValid = Object.keys(currentCard.choices).some(cardChoice => currentCard.choices[cardChoice].isChecked);

  return(
    <QuestionsWindow className={'questions'}>

      <QuestionsContainer>
        <CardContainer key={currentCard.key} className={`${currStep == 0 ? 'start' : 'nav'} ${prevStep > currStep ? 'backward' : 'forward'}`}>

          {currentCard.cardSubheader ? (
            <ElementHTML tag={'h5'} content={currentCard.cardSubheader} styling={eyebrow} />
          ) : ''}

          <ElementHTML tag={'h1'} content={currentCard.title} styling={h1style} />

          {currentCard.cardDescription ? (
            <ElementHTML tag={'h3'} content={currentCard.cardDescription} styling={longDescription} />
          ) : ''}

          <ChoicesContainer>

            <Choices currentCard={currentCard} cardChoiceChange={cardChoiceChange} />

            {currentCard.expandCollapse ? (
              <>
                <Button
                  iconBefore={extraIcon}
                  onClick={toggleCardContent}
                  appearance={'link'}>
                  {currentCard.expandCollapseLabel}
                </Button>

                {currentCard.isShowingExtraContent ? (
                  <ElementHTML content={currentCard.extraContent} styling={extraContent} />
                ): ""}
              </>
            ) : ""}
          </ChoicesContainer>
        </CardContainer>

        <NavigationBar className={currStep == 0 ? 'start' : 'nav'}>
          {currStep > 0 ? (
            <>
              <Button onClick={goToPreviousCard} appearance={'link'}>
                {labels.back}
              </Button>

              <ProgressBar value={currStep / maximumQuestions} />
            </>
          ) : ""}

          <Button
            onClick={cardIsValid ? goToNextCard : undefined}
            isDisabled={!cardIsValid}
            appearance={'primary'}
            >
              {currStep == 0 ? labels.start : labels.next}
          </Button>
        </NavigationBar>

      </QuestionsContainer>

      {currStep == 0 ? (
        <ElementHTML content={firstPage} />
      ) : ""}

    </QuestionsWindow>
  )
}

const backwardKeys = keyframes`
 0% { opacity: 0; left: -50px; }
 100% { opacity: 1; left: 0; }
`

const forwardKeys = keyframes`
 0% { opacity: 0; left: 50px; }
 100% { opacity: 1; left: 0; }
`

const h1style = `
  & + div {
    margin-top: 32px;
  }
`;

const eyebrow = `
  font-weight: 600;
`;

const longDescription = `
  font-weight: normal;
  font-size: 1.25rem;
  margin-bottom: 30px;
`;

const extraContent = `
  padding-left: 45px;
  padding-top: 10px;
`;

const QuestionsWindow = styled.div`
  position: relative;
  padding-top: 36px;
`;

const QuestionsContainer = styled.div`
  position: relative;
`;

const CardContainer = styled.div`
  min-height: 100vh;
  max-width: 688px;
  padding-bottom: 150px;
  padding-top: 50px;
  width: 95%;
  margin: auto;
  position: relative;

  &.start {
    min-height: 0;
  }

  &.forward {
    animation: ${forwardKeys} 600ms;
  }
  &.backward {
    animation: ${backwardKeys} 600ms;
  }
`;

const ChoicesContainer = styled.div`
  background-color: white;
  padding: 40px;
  box-shadow: 0px 3px 9px -3px;
  border: 1px solid ${colors.N50};
  border-radius: 5px;

  @media (max-width: 768px) {
    padding: 24px 16px;
  }

  svg {
    margin-bottom: 0;
  }

  button {
    font-family: inherit;
  }
`;

const NavigationBar = styled.div`
  display: grid;
  grid-gap: 20px;
  align-items: center;
  justify-content: center;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 32px 20px;
  box-shadow: 0 1px 30px -14px;
  background: #ffffff;
  z-index: 10;

  &.start {
    grid-template-columns: minmax(auto, 448px);
    position: absolute;
  }
  &.nav {
    grid-template-columns: auto minmax(auto,328px) minmax(208px, auto);

    div[role="progressbar"] span {
      background-color: ${colors.B400};
    }
  }
  button {
    justify-content: center;
  }
`;
